import ArticleEdit from "../../../components/ArticleEdit";
import { useTitle } from "../../../utils/hooks";

export default function BlogCreate() {
  useTitle("发表文章");
  return <ArticleEdit />;
}
